<template>
  <div class="location-page invisible-scrollbar">
    <section class="location-toolbar" :aria-label="$t('infrastructure.locationFilters')">
      <v-select v-model="activeSearch" class="location-status-filter" :items="statusItems" item-text="text" item-value="value" :placeholder="$t('infrastructure.status')" clearable dense solo flat hide-details @change="searchDataLocation" />
      <div class="location-search"><input v-model.trim="search" type="search" :placeholder="$t('infrastructure.search')" :aria-label="$t('infrastructure.searchLocation')" @keydown.enter="searchDataLocation" /><button type="button" :aria-label="$t('infrastructure.search')" @click="searchDataLocation"><v-icon color="white" size="24">mdi-magnify</v-icon></button></div>
      <button class="create-location" type="button" @click="OpenDataDialog('create', null)">{{ $t("infrastructure.create") }} +</button>
    </section>

    <section class="location-panel">
      <div class="location-table-wrap">
        <v-data-table class="location-table" :headers="headers" :items="ListData" :items-per-page="itemsPerPage" item-key="locationID" hide-default-footer disable-sort>
          <template v-slot:item.no="{ index }">{{ no_run + index + 1 }}</template>
          <template v-slot:item.active="{ item }"><span :class="['location-status', { inactive: !item.active }]">{{ item.active ? $t("infrastructure.active") : $t("infrastructure.inactive") }}</span></template>
          <template v-slot:item.action="{ item }"><div class="location-actions"><button type="button" :aria-label="$t('infrastructure.editNamed', { name: item.locationName || $t('infrastructure.location') })" @click="OpenDataDialog('edit', item.locationID)"><img class="location-action-icon location-action-icon--edit" src="@/assets/icons/brush.svg" alt="" aria-hidden="true" /></button><button class="delete" type="button" :disabled="!item.active || DeletingLocationID === item.locationID" :aria-label="$t('infrastructure.deleteNamed', { name: item.locationName || $t('infrastructure.location') })" @click="deleteDataLocationByID(item.locationID)"><img class="location-action-icon location-action-icon--delete" src="@/assets/icons/bag.svg" alt="" aria-hidden="true" /></button></div></template>
          <template v-slot:no-data><div class="table-empty">{{ $t("infrastructure.noLocationData") }}</div></template>
        </v-data-table>
      </div>
      <footer class="location-pagination">
        <v-pagination v-model="page" :length="pageCount" :total-visible="3" color="#00368e" @input="ChangePage(page)" />
        <v-select v-model="itemsPerPage" class="location-page-size" :items="items" dense solo flat hide-details @input="ChangePerPage(itemsPerPage)" />
      </footer>
    </section>

    <v-dialog v-model="LocationDialog" persistent max-width="513px" @input="onLocationDialogChange">
      <v-card class="location-dialog-card">
        <header class="location-dialog-header">
          <span>{{ EditStatus ? $t("infrastructure.editLocation") : $t("infrastructure.createLocation") }}</span>
          <button type="button" :aria-label="$t('infrastructure.closeLocationDialog')" @click="LocationDialog = false"><v-icon color="white" size="30">mdi-close</v-icon></button>
        </header>
        <div class="location-dialog-body">
          <label for="location-name">{{ $t("infrastructure.locationName") }}</label>
          <input id="location-name" ref="locationNameInput" v-model.trim="LocationName" :class="{ invalid: ValidationErrors.locationName }" type="text" @input="ValidationErrors.locationName = ''" @keydown.enter="saveDataLocation" />
          <p v-if="ValidationErrors.locationName" class="location-dialog-error">{{ ValidationErrors.locationName }}</p>
          <label class="mt-4" for="location-name-th">{{ $t("infrastructure.locationNameTH") }}</label>
          <input id="location-name-th" ref="locationNameTHInput" v-model.trim="LocationNameTH" :class="{ invalid: ValidationErrors.locationNameTH }" type="text" @input="ValidationErrors.locationNameTH = ''" @keydown.enter="saveDataLocation" />
          <p v-if="ValidationErrors.locationNameTH" class="location-dialog-error">{{ ValidationErrors.locationNameTH }}</p>
          <div class="location-dialog-status active-status-control" role="radiogroup" :aria-label="$t('infrastructure.locationStatus')">
            <button type="button" role="radio" :aria-checked="Active == '1'" :class="{ selected: Active == '1' }" @click="Active = '1'">{{ $t("infrastructure.active") }}</button>
            <button type="button" role="radio" :aria-checked="Active == '2'" :class="{ selected: Active == '2' }" @click="Active = '2'">{{ $t("infrastructure.inactive") }}</button>
          </div>
          <footer class="location-dialog-actions">
            <button class="cancel" type="button" @click="LocationDialog = false">{{ $t("infrastructure.cancel") }}</button>
            <button class="save" type="button" :disabled="IsSubmitting" @click="saveDataLocation">{{ EditStatus ? $t("infrastructure.update") : $t("infrastructure.create") }}</button>
          </footer>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >{{ $t("infrastructure.loading") }}</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { reportPageDataUpdated } from "@/utils/pageDataUpdated";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "Location",
  components: {},
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      IsSubmitting: false,
      DeletingLocationID: null,
      items: [10, 15, 20, 50, 100],
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      search: "",
      activeSearch: "Active",
      no_run: 0,

      ListData: [],
      LocationID: null,
      LocationNameTH: "",
      LocationName: "",
      Active: 1,
      EditStatus: false,
      LocationDialog: false,
      ValidationErrors: { locationName: "", locationNameTH: "" },
    };
  },
  computed: {
    statusItems() {
      return [
        { text: this.$t("infrastructure.active"), value: "Active" },
        { text: this.$t("infrastructure.inactive"), value: "InActive" },
      ];
    },
    headers() {
      return [
        {
          text: this.$t("message.No"),
          value: "no", sortable: false, align: "start",
        },
        {
          text: this.$t("infrastructure.locationName"), value: "locationName", align: "start",
          sortable: false,
        },
        {
          text: this.$t("infrastructure.locationNameTH"), value: "locationNameTH", align: "start",
          sortable: false,
        },
        {
          text: this.$t("infrastructure.status"), value: "active",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("infrastructure.action"), value: "action",
          align: "center",
          sortable: false,
        },
      ];
    },
  },

  async mounted() {
    let self = this;
    await self.getDataLocationList();
  },

  methods: {
    async getDataLocationList() {
      this.LoadingDialog = true;
      try {
        const response = await axios.post(`${this.url}Location/getDataLocationList`, {
          search: this.search || "",
          page: this.page,
          perpage: this.itemsPerPage,
          active: this.activeSearch == "Active" ? true : this.activeSearch == "InActive" ? false : null,
        });
        this.throwIfSessionExpired(response);
        if (response.data.status != 0) throw new Error(response.data.message);
        this.ListData = response.data.data.listData || [];
        this.pageCount = response.data.data.totalPages ?? response.data.data.count;
        this.no_run = (this.page - 1) * this.itemsPerPage;
        reportPageDataUpdated(this);
      } catch (error) {
        await this.showRequestError(error);
      } finally {
        this.LoadingDialog = false;
      }
    },
    async ChangePage(value) { this.page = value; await this.getDataLocationList(); },
    async ChangePerPage(value) { this.page = 1; this.itemsPerPage = value; await this.getDataLocationList(); },
    async searchDataLocation() { this.page = 1; await this.getDataLocationList(); },
    async getDataLocationByID(locationID) {
      this.LoadingDialog = true;
      try {
        const response = await axios.post(`${this.url}Location/getDataLocationByID`, { locationID });
        this.throwIfSessionExpired(response);
        if (response.data.status != 0) throw new Error(response.data.message);
        const data = response.data.data;
        this.LocationID = data.locationID;
        this.LocationName = data.locationName;
        this.LocationNameTH = data.locationNameTH;
        this.Active = data.active ? "1" : "2";
        this.EditStatus = true;
        this.LocationDialog = true;
        this.focusLocationName();
      } catch (error) { await this.showRequestError(error); }
      finally { this.LoadingDialog = false; }
    },
    validateLocation() {
      this.ValidationErrors.locationName = "";
      this.ValidationErrors.locationNameTH = "";
      if (!this.LocationName || !this.LocationName.trim()) this.ValidationErrors.locationName = this.$t("infrastructure.locationNameRequired");
      else if (this.LocationName.trim().length > 200) this.ValidationErrors.locationName = this.$t("infrastructure.locationNameTooLong");
      if (!this.LocationNameTH || !this.LocationNameTH.trim()) this.ValidationErrors.locationNameTH = this.$t("infrastructure.locationNameTHRequired");
      else if (this.LocationNameTH.trim().length > 200) this.ValidationErrors.locationNameTH = this.$t("infrastructure.locationNameTHTooLong");
      return this.ValidationErrors.locationName || this.ValidationErrors.locationNameTH;
    },
    async saveDataLocation() {
      if (this.IsSubmitting || this.validateLocation()) { this.focusFirstInvalidField(); return; }
      this.IsSubmitting = true;
      this.LoadingDialog = true;
      const payload = { locationName: this.LocationName.trim(), locationNameTH: this.LocationNameTH.trim(), active: String(this.Active) === "1" };
      if (this.EditStatus) payload.locationID = this.LocationID;
      try {
        const endpoint = this.EditStatus ? "Location/editDataLocation" : "Location/addDataLocation";
        const response = await axios.post(`${this.url}${endpoint}`, payload);
        this.throwIfSessionExpired(response);
        if (response.data.status != 0) throw new Error(response.data.message);
        await Swal.fire({ icon: "success", title: this.EditStatus ? this.$t("infrastructure.updated") : this.$t("infrastructure.created"), text: this.EditStatus ? this.$t("infrastructure.updateSuccess") : this.$t("infrastructure.createSuccess"), showConfirmButton: false, timer: 1500 });
        if (!this.EditStatus) this.page = 1;
        this.LocationDialog = false;
        await this.getDataLocationList();
      } catch (error) { await this.showRequestError(error); }
      finally { this.IsSubmitting = false; this.LoadingDialog = false; }
    },
    async deleteDataLocationByID(locationID) {
      if (this.DeletingLocationID !== null) return;
      const result = await Swal.fire({ icon: "warning", title: this.$t("infrastructure.deleteLocationTitle"), text: this.$t("infrastructure.deleteLocationText"), showCancelButton: true, confirmButtonText: this.$t("infrastructure.delete"), cancelButtonText: this.$t("infrastructure.cancel"), confirmButtonColor: "#d00000" });
      if (!result.isConfirmed) return;
      this.DeletingLocationID = locationID;
      this.LoadingDialog = true;
      try {
        const response = await axios.post(`${this.url}Location/deleteDataLocationByID`, { locationID });
        this.throwIfSessionExpired(response);
        if (response.data.status != 0) throw new Error(response.data.message);
        if (this.ListData.length === 1 && this.page > 1) this.page -= 1;
        await Swal.fire({ icon: "success", title: this.$t("infrastructure.deleted"), text: this.$t("infrastructure.deleteSuccess"), showConfirmButton: false, timer: 1500 });
        await this.getDataLocationList();
      } catch (error) { await this.showRequestError(error); }
      finally { this.DeletingLocationID = null; this.LoadingDialog = false; }
    },
    OpenDataDialog(type, id) {
      if (type === "edit") { this.getDataLocationByID(id); return; }
      this.LocationID = null; this.LocationName = ""; this.LocationNameTH = ""; this.Active = "1"; this.EditStatus = false; this.LocationDialog = true; this.focusLocationName();
    },
    onLocationDialogChange(value) {
      if (value) return;
      this.LocationID = null; this.LocationName = ""; this.LocationNameTH = ""; this.Active = "1"; this.EditStatus = false; this.ValidationErrors.locationName = ""; this.ValidationErrors.locationNameTH = "";
    },
    focusLocationName() { this.$nextTick(() => this.$refs.locationNameInput?.focus()); },
    focusFirstInvalidField() {
      if (this.ValidationErrors.locationName) this.focusLocationName();
      else if (this.ValidationErrors.locationNameTH) this.$nextTick(() => this.$refs.locationNameTHInput?.focus());
    },
    throwIfSessionExpired(response) {
      const message = String(response?.data?.message || "");
      const normalized = message.toLowerCase();
      if (normalized.includes("session") && normalized.includes("expired")) { const error = new Error(message); error.isSessionExpired = true; this.$store.dispatch("ForceLogout", message); throw error; }
    },
    async showRequestError(error) {
      if (error?.isSessionExpired || error?.response?.status === 401) return;
      await Swal.fire({ icon: "warning", width: 900, text: error?.response?.data?.message || error?.message || this.$t("infrastructure.connectionError") });
    },
  },
};
</script>
<style scoped>
.location-page { min-height:calc(100vh - 125px); padding:var(--workspace-content-top) 0 60px; background:#f6f6f6; }
.location-toolbar { display:grid; grid-template-columns:385px minmax(360px,660px) 157px; align-items:center; justify-content:center; gap:23px; margin-bottom:60px; }
.location-status-filter { border-radius:60px; }
.location-status-filter ::v-deep .v-input__slot { min-height:60px; padding:0 20px 0 26px!important; border-radius:60px!important; background:#fff!important; box-shadow:0 8px 12px rgba(0,0,0,.2)!important; }
.location-status-filter ::v-deep .v-select__selection,.location-status-filter ::v-deep input { color:#595959; font-size:18px; }
.location-search { display:flex; height:60px; align-items:center; padding:7px 9px 8px 36px; border-radius:60px; background:#fff; box-shadow:0 8px 12px rgba(0,0,0,.2); }
.location-search input { min-width:0; flex:1; border:0; outline:0; color:#191c1e; font-size:20px; }
.location-search input::placeholder { color:#595959; opacity:1; }
.location-search button { display:grid; width:45px; height:45px; flex:0 0 45px; place-items:center; border:0; border-radius:50%; background:#00378e; box-shadow:0 8px 24px rgba(0,0,0,.2); }
.create-location { height:60px; border:0; border-radius:60px; background:#00378e; box-shadow:0 8px 12px rgba(0,0,0,.2); color:#fff; font-size:20px; font-weight:500; }
.location-panel { position:relative; box-sizing:border-box; min-height:436px; padding:28px 18px 110px; border-radius:30px; background:#fff; box-shadow:0 8px 24px rgba(0,0,0,.2); }
.location-table-wrap { overflow-x:auto; border-radius:30px 30px 0 0; }
.location-table { width:100%; min-width:760px; border-collapse:collapse; color:#4c4c4c; font-size:15px; }
.location-table ::v-deep .v-data-table__wrapper { overflow-x:auto; }
.location-table ::v-deep table { min-width:760px; table-layout:fixed; }
.location-table ::v-deep .v-data-table-header { background:#00378e; }
.location-table ::v-deep .v-data-table-header th { height:81px; padding:0 30px!important; border-bottom:0!important; color:#fff!important; font-size:18px; font-weight:400; white-space:nowrap; }
.location-table ::v-deep tbody td { height:66px; padding:0 30px!important; border-bottom:0!important; color:#4c4c4c; font-size:15px; }
.location-table ::v-deep th:first-child,.location-table ::v-deep td:first-child { width:8%; text-align:center; }
.location-table ::v-deep th:nth-child(2),.location-table ::v-deep td:nth-child(2),.location-table ::v-deep th:nth-child(3),.location-table ::v-deep td:nth-child(3) { width:30%; }
.location-table ::v-deep th:nth-child(4),.location-table ::v-deep td:nth-child(4),.location-table ::v-deep th:last-child,.location-table ::v-deep td:last-child { width:16%; text-align:center; }
.location-table ::v-deep tbody tr { background:#f6f6f6; }
.location-table ::v-deep tbody tr:nth-child(even) { background:#fff; }
.table-empty { padding:32px 16px; color:#595959; text-align:center; }
.location-table thead { height:81px; background:#00378e; color:#fff; font-size:18px; }
.location-table th,.location-table td { padding:0 38px; text-align:left; }
.location-table th { font-weight:400; }
.location-table th:first-child,.location-table td:first-child { width:190px; }
.location-table th:nth-child(3),.location-table td:nth-child(3) { width:430px; text-align:center; }
.location-table th:last-child,.location-table td:last-child { width:200px; text-align:center; }
.location-table tbody tr { height:66px; background:#f6f6f6; }
.location-table tbody tr:nth-child(even) { background:#fff; }
.location-status { display:inline-flex; min-width:94px; height:32px; align-items:center; justify-content:center; border-radius:18px; background:#91d589; color:#3f6840; font-size:15px; }
.location-status.inactive { background:#f1aaaa; color:#812424; }
.location-actions { display:flex; height:66px; align-items:center; justify-content:center; gap:26px; }
.location-actions button { display:grid; width:36px; height:36px; place-items:center; border:0; border-radius:50%; background:#ff8500; }
.location-actions button.delete { background:#d00000; }
.location-actions button:disabled { cursor:not-allowed; filter:grayscale(1); opacity:.42; }
.location-action-icon { display:block; object-fit:contain; }
.location-action-icon--edit { width:18px; height:18px; }
.location-action-icon--delete { width:24px; height:24px; }
.location-pagination { position:absolute; right:18px; bottom:36px; left:18px; display:flex; height:59px; align-items:center; justify-content:center; }
.location-page-size { position:absolute; right:75px; width:133px; max-width:133px; }
.location-page-size ::v-deep .v-input__slot { min-height:50px; border-radius:30px!important; background:#f6f6f6!important; box-shadow:0 2px 4px rgba(0,0,0,.25)!important; }
.location-pagination ::v-deep .v-pagination__item,.location-pagination ::v-deep .v-pagination__navigation { width:49px; min-width:49px; height:49px; border-radius:10px; }
.location-dialog-card { min-height:490px; overflow:hidden; border-radius:16px!important; background:#fff; }
.location-dialog-header { position:relative; display:flex; height:66px; align-items:center; justify-content:center; background:#00378e; color:#fff; font-size:20px; font-weight:600; }
.location-dialog-header button { position:absolute; top:15px; right:20px; display:grid; width:36px; height:36px; place-items:center; border:0; background:transparent; }
.location-dialog-body { display:flex; min-height:424px; flex-direction:column; padding:22px 22px 28px; }
.location-dialog-body label { margin:0 0 8px 2px; color:#252525; font-size:13px; font-weight:500; }
.location-dialog-body>input { width:100%; height:50px; padding:0 18px; border:1px solid #ddd; border-radius:26px; outline:none; color:#282828; font-size:14px; }
.location-dialog-body>input:focus { border-color:#00378e; box-shadow:0 0 0 3px rgba(0,55,142,.14); }
.location-dialog-body>input.invalid { border-color:#c62828; }
.location-dialog-error { margin:6px 12px 0; color:#b71c1c; font-size:12px; }
.location-dialog-status { display:flex; gap:22px; margin:30px 0 0 20px; }
.location-dialog-status button { width:140px; height:50px; border:0; border-radius:26px; background:#fff; box-shadow:0 3px 8px rgba(0,0,0,.24); color:#282828; font-size:14px; }
.location-dialog-status button.selected { border:3px solid #00378e; box-shadow:none; }
.location-dialog-actions { display:flex; justify-content:center; gap:62px; margin-top:auto; }
.location-dialog-actions button { width:170px; height:60px; border:0; border-radius:30px; font-size:16px; box-shadow:0 3px 5px rgba(0,0,0,.22); }
.location-dialog-actions .cancel { background:#eee; color:#00378e; }
.location-dialog-actions .save { background:#00378e; color:#fff; }
.location-dialog-actions button:disabled { cursor:not-allowed; opacity:.6; }
@media(max-width:1200px){.location-page{padding-right:24px;padding-left:24px}.location-toolbar{grid-template-columns:1fr 1.5fr 157px}}
@media(max-width:760px){.location-page{padding:24px 12px}.location-toolbar{grid-template-columns:1fr;gap:14px;margin-bottom:28px}.create-location{width:157px;justify-self:end}.location-panel{padding:12px 12px 150px;border-radius:16px}.location-pagination{bottom:24px}.location-page-size{right:50%;bottom:-66px;transform:translateX(50%)}.location-dialog-status{justify-content:center;gap:12px;margin-left:0}.location-dialog-status button{width:calc(50% - 6px)}.location-dialog-actions{gap:12px}.location-dialog-actions button{width:calc(50% - 6px)}}

/* Compact desktop density; dialog and mobile sizing remain unchanged. */
@media (min-width: 761px) {
  .location-dialog-card {
    min-height: 441px;
    border-radius: 14px !important;
  }
  .location-dialog-header {
    height: 59px;
    font-size: 18px;
  }
  .location-dialog-header button {
    top: 13px;
    right: 18px;
    width: 32px;
    height: 32px;
  }
  .location-dialog-body {
    min-height: 382px;
    padding: 20px 20px 25px;
  }
  .location-dialog-body label {
    margin-bottom: 7px;
    font-size: 12px;
  }
  .location-dialog-body > input {
    height: 45px;
    padding: 0 16px;
    border-radius: 23px;
    font-size: 13px;
  }
  .location-dialog-status {
    gap: 20px;
    margin: 27px 0 0 18px;
  }
  .location-dialog-status button {
    width: 126px;
    height: 45px;
    border-radius: 23px;
    font-size: 13px;
  }
  .location-dialog-actions {
    gap: 56px;
  }
  .location-dialog-actions button {
    width: 153px;
    height: 54px;
    border-radius: 27px;
    font-size: 14px;
  }

  .location-page {
    min-height: calc(100vh - 104px);
    padding: 36px 0;
  }
  .location-toolbar {
    grid-template-columns: minmax(240px, 320px) minmax(360px, 560px) 126px;
    gap: 16px;
    margin-bottom: 28px;
  }
  .location-status-filter ::v-deep .v-input__slot {
    min-height: 46px;
    padding: 0 17px !important;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16) !important;
  }
  .location-status-filter ::v-deep .v-select__selection,
  .location-status-filter ::v-deep input,
  .location-search input {
    font-size: 15px;
  }
  .location-search,
  .create-location {
    height: 46px;
  }
  .location-search {
    padding: 5px 6px 5px 22px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  }
  .location-search button {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
    box-shadow: none;
  }
  .create-location {
    font-size: 16px;
  }
  .location-panel {
    min-height: 360px;
    padding: 20px 14px 90px;
    border-radius: 16px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.16);
  }
  .location-table-wrap {
    border-radius: 12px 12px 0 0;
  }
  .location-table ::v-deep .v-data-table-header th {
    height: 56px;
    padding: 0 20px !important;
    font-size: 15px;
  }
  .location-table ::v-deep tbody td {
    height: 50px;
    padding: 0 20px !important;
    font-size: 13px;
  }
  .location-status {
    min-width: 78px;
    height: 26px;
    font-size: 13px;
  }
  .location-actions {
    height: 50px;
    gap: 16px;
  }
  .location-actions button {
    width: 34px;
    height: 34px;
  }
  .location-pagination {
    right: 14px;
    bottom: 24px;
    left: 14px;
    height: 44px;
  }
  .location-page-size {
    right: 30px;
    width: 112px;
    max-width: 112px;
  }
  .location-page-size ::v-deep .v-input__slot {
    min-height: 42px;
  }
  .location-pagination ::v-deep .v-pagination__item,
  .location-pagination ::v-deep .v-pagination__navigation {
    width: 40px;
    min-width: 40px;
    height: 40px;
    border-radius: 8px;
  }
}
</style>
